import { Component, Vue } from 'vue-property-decorator';
import associationModule from '@/store/modules/association.module'
import { Association } from '@/shared/dtos/association';
import DxDataGrid, { DxSelection, DxPaging, DxHeaderFilter, DxEditing, DxColumn, DxFilterRow, DxFilterPanel, DxExport, DxColumnChooser } from 'devextreme-vue/data-grid';



@Component({
    components: {
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxHeaderFilter,
        DxEditing,
        DxColumn,
        DxFilterRow,
        DxFilterPanel,
        DxExport,
        DxColumnChooser
    },
})

export default class AssociationLista extends Vue {

    public pageSize: number = 15;
    public maxWidth: number = 500;
    public addHidden = true;
    public loading = false;
    public search = '';
    public association: Association = new Association();

    public get associationList() {
        return associationModule.associations;
    }

    public get columns() {
        return [
            { dataField: 'id', allowEditing: false },
            { dataField: 'code', caption: this.$tc('maestro-configuracion.codigo'), allowEditing: true },
            { dataField: 'description', caption: this.$tc('maestro-configuracion.descripcion'), allowEditing: true},
        ]
    }

    public mounted() {
        associationModule.getAssociations();
    }

    public rowInserted(e: any){
        associationModule.insertarAssociation(e.data);
    }

    public rowUpdated(e: any){
        associationModule.modificarAssociation(e.data);
    }
    
    public rowRemoved(e: any){
        associationModule.eliminarAssociation(e.key);
    }

    public initNewRow(e: any){
        e.data.id = 0;
    }
}